import { render, staticRenderFns } from "./resultTab.vue?vue&type=template&id=8f0991f4"
import script from "./resultTab.vue?vue&type=script&lang=js"
export * from "./resultTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0991f4')) {
      api.createRecord('8f0991f4', component.options)
    } else {
      api.reload('8f0991f4', component.options)
    }
    module.hot.accept("./resultTab.vue?vue&type=template&id=8f0991f4", function () {
      api.rerender('8f0991f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/result/resultTab.vue"
export default component.exports